// Top bar. Desktop: search + theme toggle + profile. Phones: compact app bar with
// brand, search icon (opens an in-bar search field), theme toggle and avatar.
import React, { useEffect, useRef } from "react";
import { Moon, Search, Sun, X } from "lucide-react";
import ProfileMenu from "./ProfileMenu";

export const THAPAR_LOGO_URL =
  "https://ik.imagekit.io/7khjnlfow/email-assets/Thapar_Logo.png?updatedAt=1769371086744";

const WorkspaceHeader = ({
  query,
  onQueryChange,
  searchOpen,
  onSearchOpenChange,
  theme,
  onToggleTheme,
  profile,
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (searchOpen) inputRef.current?.focus();
  }, [searchOpen]);

  const clearSearch = () => {
    onQueryChange("");
    onSearchOpenChange(false);
  };

  const nextThemeLabel = theme === "dark" ? "Switch to light mode" : "Switch to dark mode";

  return (
    <header className="cc-header">
      <div className="cc-brand">
        <span className="cc-logo">
          <img src={THAPAR_LOGO_URL} alt="Thapar Institute logo" />
        </span>
        <span className="cc-brand__name">Campus Connect</span>
      </div>

      <div className="cc-search" role="search">
        <Search aria-hidden="true" />
        <input
          ref={inputRef}
          type="search"
          value={query}
          placeholder="Search dashboards, portals, pages…"
          aria-label="Search dashboards, portals and pages"
          autoComplete="off"
          enterKeyHint="search"
          onChange={(event) => onQueryChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Escape") clearSearch();
          }}
        />
        {(query || searchOpen) && (
          <button type="button" className="cc-search__clear" aria-label="Clear search" onClick={clearSearch}>
            <X size={18} aria-hidden="true" />
          </button>
        )}
      </div>

      <div className="cc-header__spacer" />

      <button
        type="button"
        className="cc-icon-btn cc-search-toggle"
        aria-label="Search"
        onClick={() => onSearchOpenChange(true)}
      >
        <Search aria-hidden="true" />
      </button>
      <button
        type="button"
        className="cc-icon-btn cc-theme-toggle"
        aria-label={nextThemeLabel}
        title={nextThemeLabel}
        onClick={onToggleTheme}
      >
        {theme === "dark" ? <Sun aria-hidden="true" /> : <Moon aria-hidden="true" />}
      </button>
      <ProfileMenu {...profile} />
    </header>
  );
};

export default WorkspaceHeader;
